import axiosTokenInstance from '../../../services/api/backoffice';
import { CHANGE_ZONE, CHANGE_ZONE_ERROR } from '_models/redux/types';

// Action function
export const postChangeZone = (params) => async (dispatch) => {
  const { ticket_id, zone } = params || {
    ticket_id: undefined,
    zone: undefined,
  };

  const paramsData = {
    zone: parseInt(zone),
  };

  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.post(
      `/api/support/tickets/${ticket_id}/actions/v2/nir-change`,
      paramsData,
    );

    dispatch({
      type: CHANGE_ZONE,
      payload: response || {},
    });
  } catch (e) {
    dispatch({
      type: CHANGE_ZONE_ERROR,
      payload: e || {},
    });
  }
};
